import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import LinearProgress from '@material-ui/core/LinearProgress';

import { useLoader } from '../../../context/loader';

import { styles } from './styles';
import AppLogo from '../../../images/app-logo.svg';

export default function Loader() {
  const classes = styles();
  const {
    state: { isOpen, message },
  } = useLoader();

  return (
    <Dialog
      open={isOpen}
      className={classes.alertDialog}
      PaperProps={{
        style: {
          backgroundColor: '#FFF',
          // boxShadow: 'none',
          minWidth: '200px',
          height: '200px',
        },
      }}
    >
      <div className={classes.appLogoDiv}>
        <img src={AppLogo} className={classes.appLogo} />
      </div>
      <div className={classes.loaderMessage}>{message}</div>
      <LinearProgress className={classes.loaderBar} />
    </Dialog>
  );
}
